<div *ngIf="!initDone" [class]="className">
  <div class="loader">
    <div>
      <mat-progress-spinner diameter="50" color="primary" mode="indeterminate"></mat-progress-spinner>
    </div>
  </div>
</div>
